import { render } from "./MarkdownRenderer.vue?vue&type=template&id=262412e3"
import script from "./MarkdownRenderer.vue?vue&type=script&lang=js"
export * from "./MarkdownRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__